import type { EventSeriesOrderData } from '@beat-venues/common-types';
import {
    CalendarLightIcon,
    EventPracticalTile,
    Heading,
    Modal,
} from '@beat-venues/ui/react';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ICalTileProps {
    event: EventSeriesOrderData;
}

export const ICalTile = ({ event }: ICalTileProps): ReactElement => {
    const { t } = useTranslation();

    const [modalIsShown, setModalIsShown] = useState(false);

    return (
        <div>
            <EventPracticalTile
                icon={<CalendarLightIcon size="xl" />}
                subTitle={t('events.iCalSubTitle') || ''}
                title={t('events.iCalTitle')}
                onClick={() => {
                    setModalIsShown(true);
                }}
            />

            {event && event.endDate && event.startDate && (
                <Modal
                    className="fixed top-0 z-50 flex w-screen justify-center backdrop-blur-2xl"
                    isShown={modalIsShown}
                    onClose={() => setModalIsShown(false)}
                >
                    <Modal.Header onClose={() => setModalIsShown(false)}>
                        <Heading as="h4" className="mb-0">
                            {t('events.iCalTitle')}
                        </Heading>
                    </Modal.Header>
                    <Modal.Content>
                        <div className="overflow-hidden rounded">
                            <AddToCalendarButton
                                buttonStyle="none"
                                buttonsList={true}
                                customLabels={{
                                    ical: t('reminder.label.ical'),
                                }}
                                endDate={event.endDate}
                                endTime={event.endTime}
                                hideCheckmark={true}
                                location={
                                    t(`venues.${event?.venueId}.name`) || ''
                                }
                                name={`${event?.name} ticket reminder`}
                                options={[
                                    'Apple',
                                    'Google',
                                    'Outlook.com',
                                    'iCal',
                                ]}
                                startDate={event.startDate}
                                startTime={event.startTime}
                                timeZone="Europe/Brussels"
                            ></AddToCalendarButton>
                        </div>
                    </Modal.Content>
                </Modal>
            )}
        </div>
    );
};
